<template>
  <b-modal
    @close="closeDecisionModal()"
    hide-footer
    v-model="vModel"
    size="xl"
    :title="'Décision - Demande d\'alignement individuel'"
  >
    <ValidationObserver v-slot="{ handleSubmit }">
      <b-form @submit.prevent="handleSubmit(decision)">
        <b-row>
          <b-col lg="5" md="3" sm="12" cols="12">
            <label class="control-label">Annexe 1 (PDF):</label>
          </b-col>
          <b-col lg="6" md="9" sm="12" cols="12">
            <b-form-file
              browse-text="Ouvrir"
              v-model="annexe1.file"
              placeholder="Choisissez un fichier ou glissez le ici..."
              drop-placeholder="Glissez un Fichier ici..."
              accept="application/pdf"
            ></b-form-file>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="5" md="3" sm="12" cols="12">
            <label class="control-label">Annexe 2 (PDF):</label>
          </b-col>
          <b-col lg="6" md="9" sm="12" cols="12">
            <b-form-file
              browse-text="Ouvrir"
              v-model="annexe2.file"
              placeholder="Choisissez un fichier ou glissez le ici..."
              drop-placeholder="Glissez un Fichier ici..."
              accept="application/pdf"
            ></b-form-file>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="4" md="3" sm="12" cols="12">
            <b-button class="mr-5" size="sm" @click="addRue()"
              ><font-awesome-icon icon="plus"></font-awesome-icon>
              Ajouter une rue
            </b-button>
          </b-col>
          <b-col lg="8" md="3" sm="12" cols="12">
            <p class="info-title">
              <font-awesome-icon
                style="margin-right: 5px"
                icon="map-marker-alt"
              ></font-awesome-icon>
              {{ dossierSelected.addressNum }}
              {{ dossierSelected.addressExt }}
              {{ dossierSelected.addressType }}
              {{ dossierSelected.addressName }}
              {{ dossierSelected.addressPostalCode }}
              {{ dossierSelected.addressCity }}
            </p>
          </b-col>
        </b-row>
        <div v-for="(rue, indexR) in pointsTab" :key="rue.id">
          <b-row>
            <b-col lg="3" md="3" sm="12" cols="12">
              <label class="control-label">Rue {{ indexR + 1 }}:</label>
            </b-col>
            <b-col lg="5" md="9" sm="12" cols="12">
              <b-form-input v-model="rue.name"></b-form-input>
            </b-col>
            <b-col lg="2" md="3" sm="12" cols="12">
              <b-button
                class="center-icone"
                size="sm"
                variant="danger"
                @click="removeRue(indexR)"
                ><font-awesome-icon icon="times"></font-awesome-icon></b-button
            ></b-col>
          </b-row>
          <b-row>
            <b-col lg="3" md="3" sm="12" cols="12">
              <label class="control-label">Compétence :</label>
            </b-col>
            <b-col lg="6" md="9" sm="12" cols="12">
              <b-form-radio-group v-model="rue.competence" @change="onCompetenceChange(rue)">
                <b-form-radio name="competence" value="Communautaire">Communautaire</b-form-radio>
                <b-form-radio name="competence" value="RD">RD</b-form-radio>
                <b-form-radio name="competence" value="Privée">Privée</b-form-radio>
              </b-form-radio-group>
            </b-col>
          </b-row>
          <b-row v-if="rue.competence === 'Communautaire'">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">Point</th>
                  <th scope="col">Type</th>
                  <th scope="col">Distance en m</th>
                  <th scope="col">
                    <b-button
                      variant="success"
                      size="sm"
                      @click="addPoint(indexR)"
                    >
                      <font-awesome-icon icon="plus"></font-awesome-icon></b-button>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(point, indexP) in rue.points" :key="point.id">
                  <td>
                    <b-form-input v-model="point.name"></b-form-input>
                  </td>
                  <td>
                    <b-form-select
                      v-model="point.type"
                      :options="optionsTypeAlignement"
                    ></b-form-select>
                  </td>
                  <td>
                    <b-form-input
                      v-model="point.distance"
                      type="number"
                      step="0.0001"
                    ></b-form-input>
                  </td>
                  <td>
                    <b-button
                      size="sm"
                      variant="danger"
                      @click="removePoint(indexP, indexR)"
                      ><font-awesome-icon icon="trash"></font-awesome-icon
                    ></b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-row>
        </div>
        <div v-for="(mail, index) in request.mailArreteSignes" :key="mail.id">
          <b-row>
            <b-col lg="4" md="6" sm="12" cols="12">
              <label
                ><b>{{ index + 1 }}</b
                >, Mail :</label
              >
              <ValidationProvider
                mode="lazy"
                v-slot="{ errors }"
                rules="required|email"
                name="email"
              >
                <b-form-input v-model="mail.mail"></b-form-input>
                <div class="error">{{ errors[0] }}</div>
              </ValidationProvider>
            </b-col>
            <b-col lg="4" md="6" sm="12" cols="12">
              <label>Dénomination:</label>
              <b-form-input v-model="mail.name"></b-form-input>
            </b-col>
            <b-col lg="1" md="6" sm="12" cols="12">
              <b-button
                class="center-icone"
                size="sm"
                variant="danger"
                style="margin-top: 40px"
                @click="removeDestinataire(index)"
                ><font-awesome-icon icon="times"></font-awesome-icon
              ></b-button>
            </b-col>
          </b-row>
        </div>
        <b-row>
          <b-col lg="3" md="6" sm="12" cols="12" v-if="showBtnArreteEdition">
            <b-button
              class="mr-5 mb-2"
              variant="primary"
              size="sm"
              @click="doArrete()"
              :disabled="showBtnGen"
              >Générer l'arrêté
            </b-button>
          </b-col>
          <b-col
            lg="3"
            md="6"
            sm="12"
            cols="12"
            v-if="showBtnArreteEdition == false"
          >
            <b-button
              class="mr-5 mb-2"
              variant="primary"
              size="sm"
              @click="editArrete()"
              :disabled="showBtnArreteEdition"
              >Éditer l'arrêté
            </b-button>
          </b-col>
          <b-col
            lg="3"
            md="6"
            sm="12"
            cols="12"
            v-if="showBtnArreteEdition == false"
          >
            <b-button size="sm" variant="danger" @click="removeCourrier()"
              >Supprimer l'arrêté</b-button
            >
          </b-col>

          <b-col
            lg="3"
            md="6"
            sm="12"
            cols="12"
            v-if="
              !showBtnArreteEdition &&
                ((request.cerfa1402301 != null &&
                  request.individualAlignmentRequest == null) ||
                  (request.cerfa1402301 &&
                    request.cerfa1402301.isAccessDevelopment == false) ||
                  (request.individualAlignmentRequest != null &&
                    request.cerfa1402301 == null))
            "
          >
            <b-button
              type="submit"
              :disabled="showBtnArreteEdition"
              class="mr-5"
              variant="success"
              size="sm"
              >Signature
            </b-button>
          </b-col>
          <b-col lg="3" md="6" sm="12" cols="12">
            <b-button variant="white" size="sm" @click="closeDecisionModal()"
              >Fermer et sauvegarder
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </ValidationObserver>
  </b-modal>
</template>
<script>
import router from "../../router/index.js";
import Vuex from "vuex";
export default {
  props: ["value"],
  data() {
    return {
      optionsTypeAlignement: [
        "clou OGE",
        "borne OGE nouvelle",
        "borne OGE existante",
        "angle mur",
        "angle clôture",
        "nu du mur",
      ],
      annexe1: {
        file: null,
        typeDocument: {},
      },
      annexe2: {
        file: null,
        typeDocument: {},
      },
    };
  },
  methods: {
    addDestinataire() {
      let newDestinataire = {
        id: null,
        email: null,
      };
      this.request.mailArreteSignes.push(newDestinataire);
    },

    removeDestinataire(index) {
      this.request.mailArreteSignes.splice(index, 1);
    },
    ...Vuex.mapActions("Document", ["sendDocument"]),
    ...Vuex.mapActions("Cerfa", ["setAlignement", "updateAlignement"]),
    onCompetenceChange(rue) {
        if (rue.competence === 'RD' || rue.competence === 'Privée') {
            rue.points = [];
        }
    },
    async doArrete() {
      this.request.individualAlignmentRequest.isFavorable = true;
      this.request.instructeurId = this.userConnected.id;
      this.request.type = null;

      await this.updateAlignement(this.request.individualAlignmentRequest);
      this.request.individualAlignmentRequest.ruespointVars = "<p><table><tbody>";
      for (
        var i = 0;
        i < this.request.individualAlignmentRequest.rues.length;
        i++
      ) {
        let competence = this.request.individualAlignmentRequest.rues[i].competence;
        let phraseCompetence = '';

        switch (competence) {
            case 'RD':
              phraseCompetence = '<p style="font-style: italic; font-size: x-small; line-height: 150%;">La voie concernée est une voie départementale, hors de la compétence de de communauté de communes MACS</p>'
              break;
            case 'Privée': 
              phraseCompetence = '<p style="font-style: italic; font-size: x-small; line-height: 150%;">La voie concernée est une voie privée, hors de la compétence de de communauté de communes MACS</p>';
              break;
            default:
              phraseCompetence = ''
              break;
          }

        this.request.individualAlignmentRequest.ruespointVars +=
          '<tr><td colspan="3"><p style="font-weight: bold; line-height: 150%;">Rue '
            + (i+1) + ': ' 
            + this.request.individualAlignmentRequest.rues[i].name
            + '</p>'
            + phraseCompetence
            + '</td></tr>'
        if (this.request.individualAlignmentRequest.rues[i].points.length > 0) {
              
              this.request.individualAlignmentRequest.ruespointVars += '<tr><td style="font-weight: bold">Point</td><td style="font-weight: bold">Type</td><td style="font-weight: bold">Distance</td></tr>';

              for (
                var j = 0;
                j < this.request.individualAlignmentRequest.rues[i].points.length;
                j++
              ) {
                var type = this.request.individualAlignmentRequest.rues[i].points[j]
                  .type;
                var distance = this.request.individualAlignmentRequest.rues[i]
                  .points[j].distance;
                var name = this.request.individualAlignmentRequest.rues[i].points[j]
                  .name;
                this.request.individualAlignmentRequest.ruespointVars +=
                  '<tr><td style="width: 30%">Point ' +
                  name +
                  '</td><td style="width: 40%">' +
                  type +
                  '</td><td style="width: 30%">' +
                  distance +
                  " mètre(s)</td></tr>";
                
              }
        }
      }

      this.request.individualAlignmentRequest.ruespointVars += "</tbody></table></p>";

      let ruespointVars = this.request.individualAlignmentRequest.ruespointVars;
      // console.log(this.request.individualAlignmentRequest.rues);
      // return true;

      //ATTENTION FIX URGENCE pas de tableau pour OnlyOffice !
      this.request.stateId = 999;
      this.request.sendToSign = false;

      //Token qui peut servier pour sécuriser la route pour édition de l'arrêté
      // this.request.tokenUser = window.$cookies.get("token-sudthd");

      //noMail permet de mettre à jour la request sans envoyer de mail, quand la request conserve son stateId 3
      this.request.noMail = true;
      await this.updateDossier(this.request);

      let dataToSend = {};

      Object.flatten = function(data) {
        var result = {};
        function recurse(cur, prop) {
          if (Object(cur) !== cur) {
            result[prop] = cur;
          } else if (Array.isArray(cur)) {
            for (var i = 0, l = cur.length; i < l; i++)
              recurse(cur[i], prop + "[" + i + "]");
            if (l == 0) result[prop] = null;
          } else {
            var isEmpty = true;
            for (var p in cur) {
              isEmpty = false;
              recurse(cur[p], prop ? prop + "_" + p : p);
            }
            if (isEmpty && prop) result[prop] = {};
          }
        }
        recurse(data, "");
        return result;
      };

      this.pointsTab.forEach((e) => {
        //Si une rue possède un tab point:[] vide alors on le transforme en null
        if (e.points.length == 0) {
          e.points = null;
        }
        //Object.flatten n'arrive pas à applatir le tab des points
      });

      dataToSend = Object.flatten(this.request);
      //ATTENTION FIX URGENCE pas de tableau pour OnlyOffice !
      //Les données nécessaires sont récupérées dans le back
      delete dataToSend.petitioner_beneficiaryRequests;
      delete dataToSend.ticketOffices;
      delete dataToSend.mailArreteSignes;
      delete dataToSend.beneficiary_petitionerRequests;
      delete dataToSend.documents;
      delete dataToSend.individualAlignmentRequest_rues;

      dataToSend.individualAlignmentRequest_ruespointVars = ruespointVars;
      dataToSend.beneficiaryIsPetitioner = this.request.beneficiary == null;

      await this.startMerge(dataToSend);
      await this.getDossier(this.request.id);
    },
    async removeCourrier() {
      let doc = false;
      if (this.request.documents) {
        this.request.documents.forEach(function(element) {
          if (element.typeDocument.id == 93) {
            doc = element;
          }
        });
      }
      // console.log(doc);
      await this.removeDocument(doc.id);
      await this.getDossier(this.request.id);
      return;
      // this.$emit("removeDocument", doc);
    },
    editArrete() {
      let docArreteid = null;
      if (this.request.documents) {
        this.request.documents.forEach(function(element) {
          if (element.typeDocument.id == 93) {
            docArreteid = element.id;
          }
        });
      }
      if (docArreteid !== null) {
        let url = window.urlapi + 'onlyoffice/' + docArreteid;

        fetch(url, {
            method: "GET",
            headers: {
              Authorization: "Bearer " + window.$cookies.get("token-sudthd")
            }
          })
          .then(async (response) => {
            if (!response.ok) {
              const text = await response.text();
              throw new Error(`Erreur ${response.status} : ${text}`);
            }
            return response.text();
          })
          .then((html) => {
            const newWindow = window.open();
            if (newWindow) {
              newWindow.document.open();
              newWindow.document.write(html);
              newWindow.document.close();
            } else {
              Vue.prototype.$awn.alert("Impossible d'ouvrir une nouvelle fenêtre.");
            }
          })
          .catch((error) => {
            console.error("Erreur lors de l'ouverture du courrier :", error);
            Vue.prototype.$awn.alert("Erreur lors de l'ouverture du courrier : " + error.message, {
              position: "bottom-right",
              timeout: 5000,
            });
          });
      } else {
        alert("Aucun arrêté de généré pour cette demande");
      }
    },
    async closeDecisionModal() {
      this.annexe1 = {
        file: null,
        typeDocument: {},
      };
      this.annexe2 = {
        file: null,
        typeDocument: {},
      };
      this.arrete = {
        file: null,
        typeDocument: {},
      };
      this.request.sendToSign = false;
      //Une demande d'alignement est toujours favorable
      this.request.individualAlignmentRequest.isFavorable = true;
      this.request.instructeurId = this.userConnected.id;
      this.request.type = null; //Pour éviter l'envoi d'un array pour onlyoffice
      await this.updateAlignement(this.request.individualAlignmentRequest);
      //noMail permet de mettre à jour la request sans envoyer de mail, quand la request conserve son stateId 3
      this.request.noMail = true;
      await this.updateDossier(this.request);
      this.vModel = false;
    },
    addRue() {
      let newRue = {
        id: null,
        name: null,
        competence: null,
        individual: this.request.individualAlignmentRequest.id,
        points: [],
      };
      this.pointsTab.push(newRue);
    },
    addPoint(indexRue) {
      //Je ne peux pas ajouter de point dans une nouvelle rue
      let newPoint = {
        id: null,
        name: null,
        type: null,
        distance: null,
        rue: indexRue,
      };
      this.pointsTab[indexRue]["points"].push(newPoint);
    },
    removePoint(indexP, indexR) {
      this.pointsTab[indexR]["points"].splice(indexP, 1);
    },
    removeRue(indexR) {
      this.pointsTab.splice(indexR, 1);
    },
    async decision() {
      //Condition pour création d'une annexe
      if (this.annexe1.file == null && this.annexe2.file == null) {
        this.request.doAnnexe = false;
      }
      if (this.annexe1.file != null) {
        if (this.annexe1.file.type != "application/pdf") {
          alert("L'annexe 1 n'est pas un type : \"application/pdf\"");
          return false;
        } else {
          this.annexe1.file.requestId = this.request.id;
          this.annexe1.file.typeDocumentId = 97;
          this.annexe1.file.stdUserId = this.userConnected.id;
          this.request.doAnnexe = true;
          await this.sendDocument(this.annexe1.file);
        }
      }
      if (this.annexe2.file != null) {
        if (this.annexe2.file.type != "application/pdf") {
          alert("L'annexe 2 n'est pas un type : \"application/pdf\"");
          return false;
        } else {
          this.annexe2.file.requestId = this.request.id;
          this.annexe2.file.typeDocumentId = 97;
          this.annexe2.file.stdUserId = this.userConnected.id;
          this.request.doAnnexe = true;
          await this.sendDocument(this.annexe2.file);
        }
      }
      //MAJ alignement
      this.request.individualAlignmentRequest.isFavorable = true;
      this.request.instructeurId = this.userConnected.id;
      await this.updateAlignement(this.request.individualAlignmentRequest);
      //MAJ dossier
      this.request.state.id = 3;
      this.request.stateId = 3;
      this.request.sendToSign = true;
      this.request.instructeurId = this.userConnected.id;

      this.request.noMail = true;
      await this.updateDossier(this.request);
      this.vModel = false;

      this.sendToClicmap(this.request.id);
    },
    ...Vuex.mapActions("Document", ["removeDocument"]),
    ...Vuex.mapActions("Dossiers", [
      "getDossier",
      "updateDossier",
      "setDossier",
      "startMerge",
      "extension",
      "updateReception",
      "getReception",
      "addReception",
      "sendToClicmap",
    ]),
  },
  computed: {
    pointsTab: {
      get() {
        if (this.request.individualAlignmentRequest) {
          return this.request.individualAlignmentRequest.rues;
        } else {
          return [];
        }
      },
      set(value) {
        this.setAlignement(value);
      },
    },
    showBtnGen() {
      let disabled = true;
      if (this.request.individualAlignmentRequest !== null) {
        disabled = false;
      }
      return disabled;
    },
    showBtnArreteEdition() {
      //Si dans la liste des docs tu as un arrêté avec type 93 ? alors on récup sont ID pour construire urlOpenDoc
      let disabled = true;
      if (this.request.documents) {
        this.request.documents.forEach(function(element) {
          if (element.typeDocument.id == 93) {
            disabled = false;
          }
        });
      }
      return disabled;
    },
    request: {
      get: function() {
        return this.dossierSelected;
      },
      set: function(newValue) {
        this.setDossier(newValue);
      },
    },
    vModel: {
      get: function() {
        return this.value;
      },
      set: function(newValue) {
        this.$emit("input", newValue);
      },
    },
    ...Vuex.mapGetters("Dossiers", [
      "dossierSelected",
      "features",
      "managers",
      "reception",
      "urlOpenDoc",
    ]),
    ...Vuex.mapGetters("Authentification", ["userConnected"]),
  },
  mounted() {
    this.pointsTab.forEach((rue, index) => {
        this.$watch(
            () => rue.competence,
            (newVal) => {
                if (newVal === 'RD' || newVal === 'Privée') {
                    this.pointsTab[index].points = [];
                }
            }
        );
    });
  },
};
</script>
